<div class="notes">
  <div class="decorated-heading">Бележки</div>

  <div class="content-div">
    <div class="promises-reminder-div">
      <itfg-reminder [openedCredit]="openedCredit"></itfg-reminder>

      <itfg-payment-promises
        [openedCredit]="openedCredit"
      ></itfg-payment-promises>
    </div>

    <div class="note-div">
      <itfg-note
        [openedCredit]="openedCredit"
        [selectedCredit]="selectedCredit"
      ></itfg-note>
    </div>
  </div>
</div>
